module.exports = __webpack_public_path__ + "static/media/unibest-banner3.75955250.png";